// removed by extract-text-webpack-plugin
module.exports = {"container":"DevicesTab-container","button":"DevicesTab-button"};